import { Component } from '@angular/core';
import { GlobalSettingsService } from '../services/global-settings.service';

@Component({
    templateUrl: './settings.component.html',
    styleUrls: [ './settings.component.scss' ]
})

export class SettingsComponent {
    loaded = false;

    public get hasChanges() {
        return this.globalSettingsService.hasChanges;
    }

    constructor(private globalSettingsService: GlobalSettingsService) {
        this.globalSettingsService.onGlobalSettingsUpdated.subscribe(
            (response) => this.loaded = response != null,
            (error) => console.log(error)
        );

        if (this.globalSettingsService.getSettings != null) {
            this.loaded = true;
            this.globalSettingsService.loadSavedSettings();
        }
    }

    saveChanges() {
        this.globalSettingsService.saveGlobalAdjustments();
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/components/settings.component.ts